export const icons: string[] = [
  "icon-qudaoqushiduibifenxi",
  "icon-guanli",
  "icon-yunyingguanli",
  "icon-admin-manage",
  "icon-shouye",
  "icon-chuangjianluyou",
  "icon-guanliyuanrenzheng",
  "icon-chuangjiangongdan",
  "icon-chuangjianwenti",
  "icon-chuangjian",
  "icon-qudaoguanli",
  "icon-qudaofenxi",
  "icon-jujue",
  "icon-jujue1",
  "icon-jujue2",
  "icon-jujueshenpi",
  "icon-sousuo2",
  "icon-chaxun",
  "icon-31tishi",
  "icon-ai53",
  "icon-pass-2-copy",
  "icon-shenhetongguo",
  "icon-xinshenqing",
  "icon-shenqing",
  "icon-tishi",
  "icon-wodeshenqing",
  "icon-apply",
  "icon-liebiao",
  "icon-permissions",
  "icon-liebiao1",
  "icon-liebiao3",
  "icon-permission-manage",
  "icon-ziyuan5",
  "icon-yonghuguanli2",
  "icon-bumenguanli2",
  "icon-yonghu",
  "icon-bumenshezhi",
  "icon-chakanbumen1",
  "icon-bumenguanli3",
  "icon-yonghuguanli3",
  "icon-a-huaban2fuben14",
  "icon-iconyonghu",
  "icon-yonghuguanli1",
  "icon-kaisuo",
  "icon-role",
  "icon-jiaoseguanli2",
  "icon-menu_js_sjqx",
  "icon-caidan2",
  "icon-caidan4",
  "icon-add1",
  "icon-adduser",
  "icon-addteam",
  "icon-appstoreadd",
  "icon-add2",
  "icon-chat_add",
  "icon-attach",
  "icon-books",
  "icon-bulletpoint",
  "icon-browse",
  "icon-browse-off",
  "icon-desktop",
  "icon-qingkonghuancun",
  "icon-zhongzhi",
  "icon-icon-qingkong",
  "icon-clear",
  "icon-jianqie",
  "icon-addNode",
  "icon-shanchu",
  "icon-sousuowenjian",
  "icon-xiangxia",
  "icon-xiangshang",
  "icon-bianji",
  "icon-zuzhibumen",
  "icon-xiangyou1",
  "icon-xiangyou3",
  "icon-sousuo",
  "icon-jiaoyijilu",
  "icon-jiaoyi",
  "icon-peizhiguanli",
  "icon-yonghuguanli",
  "icon-jiaoseguanli",
  "icon-shangjiantou",
  "icon-xiajiantou",
  "icon-youjiantou",
  "icon-zuojiantou",
  "icon-dizhiguanli",
  "icon-shezhi",
  "icon-jiaoseguanli1",
  "icon-yingyongguanli",
  "icon-icon_yingyongguanli",
  "icon-caidan",
  "icon-jiantou_yemian_xiangshang",
  "icon-jiantou_yemian_xiangxia",
  "icon-jiantou_yemian_xiangyou",
  "icon-jiantou_yemian_xiangzuo",
  "icon-xiangzuo",
  "icon-wenjianjia_o",
  "icon-fenzuguanli",
  "icon-fuzhi",
  "icon-bumenguanli",
  "icon-caidan1",
  "icon-duomeiti",
  "icon-guanggao",
  "icon-offer",
  "icon-chakan",
  "icon-bumenguanli1",
  "icon-kongxinwenhao",
  "icon-wenhao",
  "icon-chongzhiyufukuanguanli",
  "icon-eduguanli",
  "icon-edu",
  "icon-huodeedu",
  "icon-baitiaoedu",
  "icon-odbc",
  "icon-canshuweihu",
  "icon-canshuguanli",
  "icon-shuju01",
  "icon-jiekou",
  "icon-navicon-ywcs",
  "icon-shujuquanxianguanli",
  "icon-jiekou1",
  "icon-yuedu",
  "icon-shu",
  "icon-shuben",
  "icon-yunxiazai",
  "icon-dengpaotishi",
  "icon-iccopy",
  "icon-yunxiazai1",
  "icon-fuzhi1",
  "icon-fuzhi2",
  "icon-dengpao",
  "icon-icon_tianjia",
  "icon-tianjia",
  "icon-dingdan_dingdanliebiao",
  "icon-xiangqing",
  "icon-chuangjiandingdan",
  "icon-dingdan",
  "icon-hand",
  "icon-bianji2",
  "icon-offer2",
  "icon-celve",
  "icon-celveguanli",
  "icon-qudaochanpinfenpeiguanli",
  "icon-tubiao_qudao",
  "icon-liebiao6",
  "icon-liebiao5",
  "icon-jiqixuexi-",
  "icon-lianjie",
  "icon-shenpiguanli",
  "icon-shenpi",
  "icon-yishenpiliebiao-",
  "icon-shenqing1",
  "icon-jiesuanshenpi",
  "icon-shenpitixing-xiaoxiliebiao",
  "icon-zhanghuliebiao_icox",
  "icon-tongzhi1",
  "icon-tongzhi",
  "icon-xiaoxitongzhi",
  "icon-xinzeng1",
  "icon-xiaoxi",
  "icon-xinzeng",
  "icon-xiazai41",
  "icon-flow-offer",
  "icon-xiaoximoban",
  "icon-rizhi",
  "icon-mobanguanli",
  "icon-wj-rz",
  "icon-naozhong1",
  "icon-naozhong",
  "icon-wodefankui",
  "icon-wentifankui",
  "icon-hunhe",
  "icon-hunliao",
  "icon-yusuantiaozheng",
  "icon-edushouxin",
  "icon-yingsheguanxiguanli",
  "icon-yingshe",
  "icon-zhiyingshe_2",
  "icon-jianguanfengkong",
  "icon-zhibiao1",
  "icon-zhibiao21",
  "icon-changjingliuliang",
  "icon-guanjianzhibiao",
  "icon-anquan",
  "icon-tongzhi2",
  "icon-xitongshezhi1",
  "icon-shangyouxitonghuichuanpeizhi",
  "icon-shujukanban",
  "icon-shangxia",
  "icon-shangxiaqiehuan",
  "icon-xiangxia2",
  "icon-xiangshang2",
  "icon-shuzizidian",
  "icon-_canshu_canshushezhi",
  "icon-baogao2",
  "icon-xiansuoguanli",
  "icon-lianjie1",
  "icon-app",
  "icon-shangyou",
  "icon-xiayou",
  "icon-ribaotongji",
  "icon-icon-test",
  "icon-gongyongzhenma",
  "icon-gongxiang",
  "icon-partake",
  "icon-shouji",
  "icon-zengkouliang",
  "icon-queren1",
  "icon-queren",
  "icon-h",
  "icon-H",
  "icon-shujuliebiao",
  "icon-list",
  "icon-tongjishujuliebiao",
  "icon-country1",
  "icon-diqu",
  "icon-country",
  "icon-peizhiguanli1",
  "icon-jiaoyiguanli1",
  "icon-jiaoyiguanli",
  "icon-mc-ysjj",
  "icon-yunhangshangyou",
  "icon-yunhangxiayou",
  "icon-jiankong",
  "icon-shujufenxi",
  "icon-lianjie3"
];

// 获取当前目录下所有.svg的文件
const req = require.context("./", false, /\.svg$/);

// 解析获取的.svg文件的文件名称并返回
const requireAll = (requireContext: any) => {
  return requireContext.keys().map(requireContext);
};
requireAll(req);
